import React, { useContext } from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { POSContext } from "src/main/PointOfSale/Layout"

import { PaymentFlowContext } from "../../PaymentModal"
import { changeDue } from "./helpers"

const ConfirmationScreenDetails = () => {
  const {
    checkoutDetails: { paymentMethod },
  } = useContext(PaymentFlowContext)
  const { currencySymbol } = useMarina()
  const {
    cartController: {
      totals: { total },
    },
  } = useContext(POSContext)

  return (
    <div className="flex justify-between text-2xl font-semibold text-teal-600">
      <span>Change Due</span>
      <span>{`${currencySymbol}${changeDue(
        paymentMethod.cashCollected,
        total
      )}`}</span>
    </div>
  )
}

ConfirmationScreenDetails.confirmButtonLabel = "Complete Transaction"

export default ConfirmationScreenDetails
